import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FALLBACK_ID = "aoAt9qRI5Tw";

const PlayOverlay = ({ onClick }) => (
  <button
    onClick={onClick}
    data-testid="hero-video-play"
    aria-label="Play video"
    className="group absolute inset-0 z-10 flex items-center justify-center"
  >
    <span className="absolute inset-0 bg-black/25 transition-colors duration-500 group-hover:bg-black/10" />
    <span className="relative flex h-20 w-20 items-center justify-center rounded-full border border-white/40 bg-black/40 text-white backdrop-blur-md transition-all duration-500 group-hover:scale-110 group-hover:border-white group-hover:bg-white group-hover:text-black lg:h-24 lg:w-24">
      <Play className="ml-1 h-7 w-7 fill-current" />
    </span>
  </button>
);

export default function HeroVideo({ rx, ry }) {
  const [vsl, setVsl] = useState(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    fetch(`${API}/vsl`)
      .then((r) => r.json())
      .then(setVsl)
      .catch(() => setVsl({ exists: false }));
  }, []);

  return (
    <motion.div
      style={{ rotateX: rx, rotateY: ry, transformPerspective: 1400 }}
      className="relative border border-white/15 bg-black shadow-[0_40px_120px_-20px_rgba(0,0,0,0.9)]"
    >
      <div className="relative aspect-video w-full overflow-hidden bg-black">
        {vsl === null && <div className="absolute inset-0 animate-pulse bg-white/5" />}

        {vsl?.exists &&
          (playing ? (
            <video
              controls
              autoPlay
              playsInline
              poster={`${API}/vsl/poster?v=${vsl?.updated_at || "1"}`}
              className="h-full w-full"
              src={`${API}/vsl/stream`}
              data-testid="hero-video-frame"
            />
          ) : (
            <>
              <video
                preload="metadata"
                playsInline
                muted
                poster={`${API}/vsl/poster?v=${vsl?.updated_at || "1"}`}
                className="absolute inset-0 h-full w-full object-cover"
                src={`${API}/vsl/stream#t=0.1`}
                data-testid="hero-video-frame"
              />
              <PlayOverlay onClick={() => setPlaying(true)} />
            </>
          ))}

        {vsl && !vsl.exists &&
          (playing ? (
            <iframe
              src={`https://www.youtube-nocookie.com/embed/${FALLBACK_ID}?rel=0&autoplay=1`}
              title="Sergio Chavez — watch this first"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="absolute inset-0 h-full w-full"
              data-testid="hero-video-frame"
            />
          ) : (
            <>
              <img
                src={`https://i.ytimg.com/vi/${FALLBACK_ID}/maxresdefault.jpg`}
                alt="Sergio Chavez — watch this first"
                className="absolute inset-0 h-full w-full object-cover"
                data-testid="hero-video-frame"
              />
              <PlayOverlay onClick={() => setPlaying(true)} />
            </>
          ))}
      </div>
      <div className="pointer-events-none absolute inset-0 border border-white/5" />
    </motion.div>
  );
}
